import { render, staticRenderFns } from "./addEmployerClient.vue?vue&type=template&id=f55b6c22&scoped=true"
import script from "./addEmployerClient.vue?vue&type=script&lang=js"
export * from "./addEmployerClient.vue?vue&type=script&lang=js"
import style0 from "./addEmployerClient.vue?vue&type=style&index=0&id=f55b6c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55b6c22",
  null
  
)

export default component.exports